module.exports = __webpack_public_path__ + "img/logo.66009768.66009768.svg";